import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'wr-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Washington Regional Urgent Care',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1-615-988-2008,
  email: 'support@wregionalurgentcare.com',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/wr/index.js